// extracted by mini-css-extract-plugin
export default {"signup":"sign-up_signup__0PgUZ","logo":"sign-up_logo__pb8Z9","terms":"sign-up_terms__PnXZQ","button":"sign-up_button__9qBee"};